import { Categories_Enum, Projects_Metadata_Bool_Exp, Verticals_Enum } from '@/gql/generated/graphql'
import { InstagramLogoIcon } from 'design-configuration/components'
import { YoutubeLogoIcon } from 'design-configuration/components/icons'
import { FarcasterLogoIcon } from 'design-configuration/components'
import { DiscordLogoIcon } from 'design-configuration/components'
import { XLogoIcon } from 'design-configuration/components/icons'

export { default as FALLBACK_PROFILE_PIC } from './images/profile-placeholder.jpg'

export const MAX_WIDTH = 1100
export const USING_PROXY =
  process.env.NEXT_PUBLIC_USE_PROXY !== undefined ? process.env.NEXT_PUBLIC_USE_PROXY === 'true' : false

export const CURATED_BASE_PATH = USING_PROXY ? `${process.env.NEXT_PUBLIC_CURATED_BASE_PATH}` : ''

export const SESSION_KEY = 'ab-curated-session'

export const LOCAL_STORAGE_BLOCKED = 'Local storage blocked by browser'
export const PURCHASE_FEATURE_FLAG = 'curated-purchase'
export const EXHIBITIONS_FLAG = 'general-exhibitions'
export const GROUP_EXHIBITION_FLAG = 'group-exhibition'
export const SOLO_EXHIBITION_FLAG = 'solo-exhibition'

export const MPKOZ_EXHIBITION_SLUG = 'bokeh-by-mpkoz'
export const GROUP_EXHIBITION_Q4_2024_SLUG = 'poetics-of-the-infinite'
export const BUSY_EXHIBITION_SLUG = 'busy-by-james-merrill'
export const GAS_WARS_EXHIBITION_SLUG = 'gas-wars-by-jack-butcher'
export const QUINE_EXHIBITION_SLUG = 'quine-by-larva-labs'
export const TOKEN_REVALIDATE_TAG = 'token'

export const PROJECTS_CURATED_AND_COLLAB: Projects_Metadata_Bool_Exp = {
  _or: [
    { vertical_name: { _eq: Verticals_Enum.Curated } },
    { vertical: { category_name: { _eq: Categories_Enum.Collaborations } } }
  ]
}

export const HASURA_MAX_CACHE_AGE = 300
export const ONE_WEEK_CACHE_AGE = 60 * 60 * 24 * 7
export const ONE_DAY_CACHE_AGE = 60 * 60 * 24
export const ONE_HOUR_CACHE_AGE = 60 * 60
export const ONE_MILLION = 1000000
export const AVERAGE_SLOT_TIME = 12 // seconds
export const ALL_FILTER_OPTION = { label: 'All', value: 'all' }

export const COLLECTIONS_REVALIDATE_TAG = 'collections'
export const USER_REVALIDATE_TAG = 'user'
export const ARTISTS_REVALIDATE_TAG = 'artists'
export const ARTICLES_REVALIDATE_TAG = 'articles'
export const EXHIBITIONS_REVALIDATE_TAG = 'exhibitions'
export const HOME_REVALIDATE_TAG = 'home'

export const CENSORED_USER_ADDRESSES = ['0x584456aaB0110A0f1B177D8a1Cde7AFF6D09A292'].map((address) =>
  address.toLowerCase()
)

const DDUST_BY_JIWA_PROJECT_ID = '0x00000053a75735169ad44f6760c11f3d3d3b3544-0'
const OVERTURE_BY_MITCHELL_CHAN = '0x000000dab303a194b3f55d4702b24740ad5a2f00-0'
export const MARFA_RESIDENCY_PROJECT_IDS = [DDUST_BY_JIWA_PROJECT_ID]

/**
 * Projects that are minting on OpenSea SeaDrop platform
 */
export const OPENSEA_SEADROP_COLLECTION_URLS: Record<string, string> = {
  [DDUST_BY_JIWA_PROJECT_ID]: 'https://opensea.io/collection/ddust-by-jiwa',
  [OVERTURE_BY_MITCHELL_CHAN]: 'https://opensea.io/collection/overture-by-mitchell-f-chan'
}

export type SocialLink = {
  icon: React.ElementType
  href: string
}
export const SOCIAL_LINKS: SocialLink[] = [
  {
    icon: XLogoIcon,
    href: 'https://twitter.com/artblocks_io'
  },
  {
    icon: DiscordLogoIcon,
    href: 'https://discord.com/invite/artblocks'
  },
  {
    icon: FarcasterLogoIcon,
    href: 'https://warpcast.com/artblocks'
  },
  {
    icon: YoutubeLogoIcon,
    href: 'https://www.youtube.com/channel/UCJ3do9nWP6qaJkcbxZaJZ4w'
  },
  {
    icon: InstagramLogoIcon,
    href: 'https://www.instagram.com/artblocks_io'
  }
]

/**
 * Gas Wars project constants
 * These are hardcoded to reduce reads from contract and number of queries
 */
export const GAS_WARS_CONTRACT_ADDRESS = '0x65cbcaad7f53e1b3d61963c07edddc501a2c31e0'
export const GAS_WARS_CORE_CONTRACT_ADDRESS = '0xab00000000002ade39f58f9d8278a31574ffbe77'
export const GAS_WARS_AUCTION_START_TIMESTAMP = 1758124800 // read from contract, this is used as fallback
export const GAS_WARS_AUCTION_DURATION = 500 // seconds
export const GAS_WARS_AUCTION_END_TIMESTAMP = GAS_WARS_AUCTION_START_TIMESTAMP + GAS_WARS_AUCTION_DURATION
export const GAS_WARS_GENERATOR_URL = `https://generator.artblocks.io/${GAS_WARS_CORE_CONTRACT_ADDRESS}/`
export const GAS_WARS_PROJECT_ID = 505
export const GAS_WARS_MAX_INVOCATIONS = 500
export const GAS_WARS_ARMADILLO_OFFSET = 69
export const GAS_WARS_DEFAULT_PRICE_INCREMENT_IN_WEI = BigInt('221890000000000')
export const GAS_WARS_BASE_PRICE_IN_WEI = BigInt('0')
